<div class="modal-wrapper">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title" i18n="@@general.remarks">
      Remarks
    </h4>
    <i class="fas fa-times" (click)="onClose()"></i>
  </div>
  <div class="modal-body">
    <div class="card">
      <div class="card-title" i18n="@@general.remarks.general">
        General remarks
      </div>
      <textarea
        placeholder="Add remarks"
        maxlength="3000"
        [(ngModel)]="remarks"
        [disabled]="!canWrite"
      ></textarea>
    </div>
  </div>
  <div class="modal-footer">
    <button [disabled]="!canSave" class="save-button" (click)="onSave()">
      <img src="assets/Keen&Wise_save_transparant.png" />
    </button>
  </div>
</div>
